import React from 'react';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import Icon from '../../../Icon';
import Button from '../../../Button';
import styles from './styles.styl';

function VideoVisitBtn({ onStartVideoVisit, title, type, disabled }) {
  const handleVideoStart = e => {
    e.preventDefault();
    e.stopPropagation();
    onStartVideoVisit(e);
  };

  return (
    <Button
      styleName={cn('video-btn', type, { disabled })}
      onClick={handleVideoStart}
      color={type}
      border
    >
      <Icon name="icon-video" size={24} />
      <FormattedMessage id={title || 'appointment.list.card.startVisit'} />
    </Button>
  );
}

VideoVisitBtn.propTypes = {
  onStartVideoVisit: PropTypes.func,
  type: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

VideoVisitBtn.defaultProps = {
  type: 'accent',
};

export default CSSModules(VideoVisitBtn, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VideoVisitBtn/index.jsx